module.exports = __webpack_public_path__ + "static/media/deleteStroke.dc14e5ea.svg";